// extracted by mini-css-extract-plugin
module.exports = {"divider":"GroupRegistrationModal_divider__3uPgh"};